export interface AdExclusionRule {
  type: 'exact' | 'startsWith' | 'regex';
  pattern: string | RegExp;
  reason?: string;
}

export const AD_EXCLUSION_RULES: AdExclusionRule[] = [
  {
    type: 'exact',
    pattern: '/landing',
    reason: 'Landing pages should be ad-free for better conversion'
  },
  {
    type: 'exact',
    pattern: '/landingdm',
    reason: 'Digital marketing landing page should be ad-free'
  },
  {
    type: 'exact',
    pattern: '/download',
    reason: 'App download page should be ad-free for better conversion'
  },
  {
    type: 'exact',
    pattern: '/login',
    reason: 'Login page should be distraction-free'
  },
  {
    type: 'exact',
    pattern: '/signup',
    reason: 'Signup page should be distraction-free for better conversion'
  },
  {
    type: 'startsWith',
    pattern: '/admin',
    reason: 'Admin pages should be clean and professional'
  }
];

/**
 * Determines if ads should be excluded from the current route
 * @param pathname - Current route pathname
 * @returns true if ads should be excluded, false otherwise
 */
export const isRouteExcluded = (pathname: string): boolean => {
  return AD_EXCLUSION_RULES.some(rule => {
    switch (rule.type) {
      case 'exact':
        return pathname === rule.pattern;
      case 'startsWith':
        return pathname.startsWith(rule.pattern as string);
      case 'regex':
        return (rule.pattern as RegExp).test(pathname);
      default:
        return false;
    }
  });
};

/**
 * Get the exclusion reason for a given route (useful for debugging)
 * @param pathname - Current route pathname
 * @returns the exclusion reason or null if not excluded
 */
export const getExclusionReason = (pathname: string): string | null => {
  const rule = AD_EXCLUSION_RULES.find(rule => {
    switch (rule.type) {
      case 'exact':
        return pathname === rule.pattern;
      case 'startsWith':
        return pathname.startsWith(rule.pattern as string);
      case 'regex':
        return (rule.pattern as RegExp).test(pathname);
      default:
        return false;
    }
  });
  
  return rule?.reason || null;
};